import React, { ReactElement } from "react"

import {
    Box,
    Grid,
    Paper,
    Typography
} from "@mui/material"

import { Trans } from "@lingui/macro"
import { DateTime } from "luxon"

import { BrandPriority, SwitchUtils } from "models"

interface ResearchDetailCardProps {
    data: BrandPriority
}
interface ResearchDetailCardState {
}
export class ResearchDetailCard extends React.Component<ResearchDetailCardProps, ResearchDetailCardState> {
    constructor(props: ResearchDetailCardProps) {
        super(props)
        this.state = {}
    }

    componentDidMount() {
        this.setPreferredContracts()
    }

    public componentDidUpdate(
        prevProps: Readonly<ResearchDetailCardProps>,
        prevState: Readonly<ResearchDetailCardState>,
        snapshot?: any,
    ) {
        if (prevProps.data.id === this.props.data.id) {
            return
        }

        this.setPreferredContracts()
    }

    private setPreferredContracts = (): ReactElement[] => {
        let contracts: ReactElement[] = []

        if (!this.props.data.requisiteOverrides) {
            contracts.push(
                <Typography key={0}>
                    -
                </Typography>
            )
            return contracts
        }

        if (this.props.data.requisiteOverrides.preferredContractTypes.BUY) {
            contracts.push(
                <Typography key={1}>
                    <Trans id={"enums.contract-type.BUY"}>
                        Acquisto
                    </Trans>
                </Typography>
            )
        }
        if (this.props.data.requisiteOverrides.preferredContractTypes.BRANCH_LEASE) {
            contracts.push(
                <Typography key={2}>
                    <Trans id={"enums.contract-type.BRANCH_LEASE"}>
                        Affitto di ramo d'azienda
                    </Trans>
                </Typography>
            )
        }
        if (this.props.data.requisiteOverrides.preferredContractTypes.LEASE) {
            contracts.push(
                <Typography key={3}>
                    <Trans id={"enums.contract-type.LEASE"}>
                        Affitto
                    </Trans>
                </Typography>
            )
        }
        if (this.props.data.requisiteOverrides.preferredContractTypes.TEMPORARY_LEASE) {
            contracts.push(
                <Typography key={4}>
                    <Trans id={"enums.contract-type.TEMPORARY_LEASE"}>
                        Locazione temporanea
                    </Trans>
                </Typography>
            )
        }

        if (contracts.length === 0) {
            contracts.push(
                <Typography key={0}>
                    -
                </Typography>
            )
        }

        return contracts
    }

    render() {
        return (
            <Box>
                <Paper elevation={0} sx={{ bgcolor: "#e6ecff", p: 2 }}>
                    <Typography color="primary.main" sx={{ fontSize: "18px", fontWeight: '600', lineHeight: 1 }}>
                        <Trans id={"research.research-detail-card.name"}>
                            {this.props.data.name}
                        </Trans>
                    </Typography>
                    <Typography color="gray" sx={{ fontSize: "13px", fontWeight: '600' }}>
                        <Trans id={"research.research-detail-card.name"}>
                            {this.props.data.brand.name}
                        </Trans>
                    </Typography>
                    <Typography color="gray" sx={{ fontSize: "10px" }}>
                        <Trans id={"research.research-detail-card.saved_on"}>
                            Salvata il {DateTime.fromISO(this.props.data.creationDate).toFormat("dd MMM yyyy")}
                        </Trans>
                    </Typography>
                </Paper>
                <Grid container sx={{ maxHeight: "38vh", overflow: "auto", mt: 1 }}>
                    <Grid item xs={12} md={6} sx={{ paddingY: 1, borderTop: "2px solid lightgray" }}>
                        <Typography sx={{ fontSize: "14px", color: "lightgray" }}>
                            <Trans>
                                Regione
                            </Trans>
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={6} sx={{ paddingY: 1, borderTop: "2px solid lightgray" }}>
                        {this.props.data.region !== null &&
                            <Typography>
                                {this.props.data.region}
                            </Typography>
                        }
                        {this.props.data.region === null &&
                            <Typography>
                                -
                            </Typography>
                        }
                    </Grid>
                    <Grid item xs={12} md={6} sx={{ paddingY: 1, borderTop: "2px solid lightgray" }}>
                        <Typography sx={{ fontSize: "14px", color: "lightgray" }}>
                            <Trans>
                                Comune
                            </Trans>
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={6} sx={{ paddingY: 1, borderTop: "2px solid lightgray" }}>
                        {this.props.data.city !== null &&
                            <Typography>
                                {this.props.data.city}
                            </Typography>
                        }
                        {this.props.data.city === null &&
                            <Typography>
                                -
                            </Typography>
                        }
                    </Grid>
                    <Grid item xs={12} md={6} sx={{ paddingY: 1, borderTop: "2px solid lightgray" }}>
                        <Typography sx={{ fontSize: "14px", color: "lightgray" }}>
                            <Trans>
                                Via/Zona
                            </Trans>
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={6} sx={{ paddingY: 1, borderTop: "2px solid lightgray" }}>
                        {this.props.data.street !== null &&
                            <Typography>
                                {this.props.data.street}
                            </Typography>
                        }

                        {this.props.data.street === null &&
                            <Typography>
                                -
                            </Typography>
                        }
                    </Grid>
                    <Grid item xs={12} md={6} sx={{ paddingY: 1, borderTop: "2px solid lightgray" }}>
                        <Typography sx={{ fontSize: "14px", color: "lightgray" }}>
                            <Trans>
                                Posizione
                            </Trans>
                        </Typography>
                    </Grid>
                    {this.props.data.requisiteOverrides && this.props.data.requisiteOverrides.positionType === null &&
                        <Grid item xs={12} md={6} sx={{ paddingY: 1, borderTop: "2px solid lightgray" }}>
                            <Typography>
                                -
                            </Typography>
                        </Grid>
                    }
                    {this.props.data.requisiteOverrides && this.props.data.requisiteOverrides.positionType !== null &&
                        <Grid item xs={12} md={6} sx={{ paddingY: 1, borderTop: "2px solid lightgray" }}>
                            <Typography>
                                <Trans id={"enums.asset-position." + this.props.data.requisiteOverrides.positionType}>
                                </Trans>
                            </Typography>
                        </Grid>
                    }
                    {this.props.data.requisiteOverrides === null &&
                        <Grid item xs={12} md={6} sx={{ paddingY: 1, borderTop: "2px solid lightgray" }}>
                            <Typography>
                                -
                            </Typography>
                        </Grid>
                    }

                    <Grid item xs={12} md={6} sx={{ paddingY: 1, borderTop: "2px solid lightgray" }}>
                        <Typography sx={{ fontSize: "14px", color: "lightgray" }}>
                            <Trans>
                                Dimensione minima (mq)
                            </Trans>
                        </Typography>
                    </Grid>
                    {this.props.data.requisiteOverrides && (this.props.data.requisiteOverrides.minGla !== null || this.props.data.requisiteOverrides.minLandArea !== null) &&
                        <Grid item xs={12} md={6} sx={{ paddingY: 1, borderTop: "2px solid lightgray" }}>
                            <Typography>
                                {this.props.data.requisiteOverrides.minGla || this.props.data.requisiteOverrides.minLandArea}
                            </Typography>
                        </Grid>
                    }
                    {this.props.data.requisiteOverrides && this.props.data.requisiteOverrides.minGla === null && this.props.data.requisiteOverrides.minLandArea === null &&
                        <Grid item xs={12} md={6} sx={{ paddingY: 1, borderTop: "2px solid lightgray" }}>
                            <Typography>
                                -
                            </Typography>
                        </Grid>
                    }
                    {!this.props.data.requisiteOverrides &&
                        <Grid item xs={12} md={6} sx={{ paddingY: 1, borderTop: "2px solid lightgray" }}>
                            <Typography>
                                -
                            </Typography>
                        </Grid>
                    }
                    <Grid item xs={12} md={6} sx={{ paddingY: 1, borderTop: "2px solid lightgray" }}>
                        <Typography sx={{ fontSize: "14px", color: "lightgray" }}>
                            <Trans>
                                Dimensione massima (mq)
                            </Trans>
                        </Typography>
                    </Grid>
                    {this.props.data.requisiteOverrides && (this.props.data.requisiteOverrides.maxGla !== null || this.props.data.requisiteOverrides.maxLandArea !== null) &&
                        <Grid item xs={12} md={6} sx={{ paddingY: 1, borderTop: "2px solid lightgray" }}>
                            <Typography>
                                {this.props.data.requisiteOverrides.maxGla || this.props.data.requisiteOverrides.maxLandArea}
                            </Typography>
                        </Grid>
                    }
                    {this.props.data.requisiteOverrides && this.props.data.requisiteOverrides.maxGla === null && this.props.data.requisiteOverrides.maxLandArea === null &&
                        <Grid item xs={12} md={6} sx={{ paddingY: 1, borderTop: "2px solid lightgray" }}>
                            <Typography>
                                -
                            </Typography>
                        </Grid>
                    }
                    {!this.props.data.requisiteOverrides &&
                        <Grid item xs={12} md={6} sx={{ paddingY: 1, borderTop: "2px solid lightgray" }}>
                            <Typography>
                                -
                            </Typography>
                        </Grid>
                    }
                    <Grid item xs={12} md={6} sx={{ paddingY: 1, borderTop: "2px solid lightgray" }}>
                        <Typography sx={{ fontSize: "14px", color: "lightgray" }}>
                            <Trans>
                                Tipo di proprietà
                            </Trans>
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={6} sx={{ paddingY: 1, borderTop: "2px solid lightgray" }}>
                        {this.props.data.requisiteOverrides && (
                            <Typography>
                                {this.props.data.requisiteOverrides.preferredAssetType ? (
                                    <Trans id={`enums.asset-types.${this.props.data.requisiteOverrides.preferredAssetType}`}>

                                    </Trans>
                                ) : (
                                    "-"
                                )}
                            </Typography>
                        )}
                    </Grid>
                    <Grid item xs={12} md={6} sx={{ paddingY: 1, borderTop: "2px solid lightgray" }}>
                        <Typography sx={{ fontSize: "14px", color: "lightgray" }}>
                            <Trans>
                                Tipologia di contratto
                            </Trans>
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={6} sx={{ paddingY: 1, borderTop: "2px solid lightgray" }}>
                        {this.setPreferredContracts()}
                    </Grid>
                    <Grid item xs={12} md={6} sx={{ paddingY: 1, borderTop: "2px solid lightgray" }}>
                        <Typography sx={{ fontSize: "14px", color: "lightgray" }}>
                            <Trans>
                                Vetrine
                            </Trans>
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={6} sx={{ paddingY: 1, borderTop: "2px solid lightgray" }}>
                        {this.props.data.requisiteOverrides &&
                            <Typography>
                                <Trans id={`enums.switch-enum.${SwitchUtils.setSelectValue(this.props.data.requisiteOverrides.shopWindows)}`}>

                                </Trans>
                            </Typography>
                        }
                    </Grid>
                    <Grid item xs={12} md={6} sx={{ paddingY: 1, borderTop: "2px solid lightgray" }}>
                        <Typography sx={{ fontSize: "14px", color: "lightgray" }}>
                            <Trans>
                                Singolo piano
                            </Trans>
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={6} sx={{ paddingY: 1, borderTop: "2px solid lightgray" }}>
                        <Typography>
                            <Trans id={`enums.switch-enum.${SwitchUtils.setSelectValue(this.props.data.requisiteOverrides?.singleLevel || null)}`}>

                            </Trans>
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={6} sx={{ paddingY: 1, borderTop: "2px solid lightgray" }}>
                        <Typography sx={{ fontSize: "14px", color: "lightgray" }}>
                            <Trans>
                                Aria condizionata
                            </Trans>
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={6} sx={{ paddingY: 1, borderTop: "2px solid lightgray" }}>
                        <Typography>
                            <Trans id={`enums.switch-enum.${SwitchUtils.setSelectValue(this.props.data.requisiteOverrides?.airConditioning || null)}`}>

                            </Trans>
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={6} sx={{ paddingY: 1, borderTop: "2px solid lightgray", borderBottom: "2px solid lightgray" }}>
                        <Typography sx={{ fontSize: "14px", color: "lightgray" }}>
                            <Trans>
                                Parcheggi
                            </Trans>
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={6} sx={{ paddingY: 1, borderTop: "2px solid lightgray", borderBottom: "2px solid lightgray" }}>
                        <Typography>
                            <Trans id={`enums.switch-enum.${SwitchUtils.setSelectValue(this.props.data.requisiteOverrides?.parkingSlots || null)}`}>

                            </Trans>
                        </Typography>
                    </Grid>
                </Grid>
            </Box>
        )
    }
}
